<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">手机金融与购物</div>
      </div>
      <div class="haerd_right"></div>
    </div>

    <div class="module_box">
      <div class="health" @click.stop.prevent="goBankCard">
        <div class="module_left w220">微信&支付宝绑银行卡</div>

        <div class="module_right_icon1 BankCard1">
          <div class="module_right_icon2 BankCard2">
            <div class="module_right_icon3 BankCard3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goTransferAccounts">
        <div class="module_left w220">微信&支付宝转账</div>

        <div class="module_right_icon1 TransferAccounts1">
          <div class="module_right_icon2 TransferAccounts2">
            <div class="module_right_icon3 TransferAccounts3"></div>
          </div>
        </div>
      </div>

      <div class="health" @click.stop.prevent="goPayment">
        <div class="module_left w220">微信&支付宝扫码支付</div>

        <div class="module_right_icon1 Payment1">
          <div class="module_right_icon2 Payment2">
            <div class="module_right_icon3 Payment3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goWithdrawal">
        <div class="module_left w220">微信&支付宝提现</div>

        <div class="module_right_icon1 Withdrawal1">
          <div class="module_right_icon2 Withdrawal2">
            <div class="module_right_icon3 Withdrawal3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goDetails">
        <div class="module_left">手机银行查余额&明细</div>

        <div class="module_right_icon1 Details1">
          <div class="module_right_icon2 Details2">
            <div class="module_right_icon3 Details3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goOnlineShopping">
        <div class="module_left">手机网购</div>
        <div class="module_right_icon1 OnlineShopping1">
          <div class="module_right_icon2 OnlineShopping2">
            <div class="module_right_icon3 OnlineShopping3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goBankTransfer">
        <div class="module_left w220">手机银行转账</div>

        <div class="module_right_icon1 BankTransfer1">
          <div class="module_right_icon2 BankTransfer2">
            <div class="module_right_icon3 BankTransfer3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goAntiFraudAPP">
        <div class="module_left w220">使用国家反诈中心APP</div>

        <div class="module_right_icon1 AntiFraudAPP1">
          <div class="module_right_icon2 AntiFraudAPP2">
            <div class="module_right_icon3 AntiFraudAPP3"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="prompt">温馨提示：模拟体验，非真实操作。</div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data () {
    return {}
  },
  created () {},

  mounted () {},
  beforeDestroy () {},

  methods: {
    async goBack () {
      this.$router.replace({
        path: '/classification'
      })
    },
    async goAntiFraudAPP () {
      this.$router.push({ path: '/shopping/antiFraudAPP/index1' })
    },
    async goDetails () {
      this.$router.push({ path: '/shopping/details/index' })
    },
    async goBankTransfer () {
      this.$router.push({ path: '/shopping/bankTransfer/index' })
    },
    async goBankCard () {
      this.$router.push({ path: '/shopping/bankCard/index' })
    },
    async goWithdrawal () {
      this.$router.push({ path: '/shopping/withdrawal/index' })
    },
    async goTransferAccounts () {
      this.$router.push({ path: '/shopping/transferAccounts/index' })
    },
    async goPayment () {
      this.$router.push({ path: '/shopping/payment/index' })
    },
    async goOnlineShopping () {
      this.$router.push({ path: '/shopping/onlineShopping/index' })
    }
  }
}
</script>

<style scoped lang="less">
.newTop {
  top: 280px !important;
}
.newpadding {
  padding: 36px 40px 0 !important;
}
.newmargin {
  margin-top: 30px !important;
}
.Index {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  /* 线性渐变 */
  background: linear-gradient(
    180deg,
    rgb(255, 108, 108) 6.107%,
    rgb(255, 150, 150) 20.611%,
    rgb(255, 247, 228) 99.237%
  );
  background-size: 100% 100%;
  border-radius: 0px;
  .window_bg {
    pointer-events: none; /* 使点击穿透该元素 */
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/use/useIndex/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/use/useIndex/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 44px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      margin-top: 20px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 70px;
      width: 44vw;
      color: #ffffff;
      line-height: 1.2;
    }
  }
  .haerd_right {
    position: absolute;
    right: 30px;
    top: 30px;
    z-index: 0;
    width: 380px;
    height: 270px;
    background: url(@/assets/shopping/shoppingIndex/shoppingIndex_subscript.png)
      no-repeat center;
    background-size: 100% 100%;
    //   opacity: 0.7;
  }
}

.module_box {
  // width: 100%;
  // margin: 0 40px 0;
  position: absolute;
  top: 360px;
  max-height: 910px;
  overflow-y: auto;
  padding-right: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 0 30px;
  .health {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    // flex-direction: column;
    align-items: center;
    width: 325px;
    padding: 27px 0px;
    // height: 150px;
    background: #ffffff;
    border-radius: 15px;
    margin-bottom: 30px;
    margin-right: 30px;
    .module_left {
      display: flex;
      // justify-content: center;
      margin-left: 20px;
      align-items: center;
      width: 190px;
      // height: 71px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 33px;
      letter-spacing: 2px;
      color: #333333;
      // margin-left: 20px;
      z-index: 99;
    }
    .w220 {
      width: 220px;
    }
    .module_right_icon1 {
      width: 250px;
      height: 253px;
      position: absolute;
      right: -25%;
      top: -50%;
      .module_right_icon2 {
        width: 130px;
        height: 117px;
        position: absolute;
        left: 22%;
        bottom: 4.5%;
        .module_right_icon3 {
          width: 70px;
          height: 70px;
          position: absolute;
          left: 13.5%;
          top: 23.5%;
        }
      }
    }
    .BankCard1 {
      background: url("@/assets/colorBg/green1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .BankCard2 {
      background: url("@/assets/colorBg/green2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .BankCard3 {
      background: url("@/assets/shopping/shoppingIndex/bankCard.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .TransferAccounts1 {
      background: url("@/assets/colorBg/blue1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .TransferAccounts2 {
      background: url("@/assets/colorBg/blue2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .TransferAccounts3 {
      background: url("@/assets/shopping/shoppingIndex/transferAccounts.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Payment1 {
      background: url("@/assets/colorBg/pink1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Payment2 {
      background: url("@/assets/colorBg/pink2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Payment3 {
      background: url("@/assets/shopping/shoppingIndex/payment.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .Withdrawal1 {
      background: url("@/assets/colorBg/green1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Withdrawal2 {
      background: url("@/assets/colorBg/green2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Withdrawal3 {
      background: url("@/assets/shopping/shoppingIndex/withdrawal.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Details1 {
      background: url("@/assets/colorBg/purple1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Details2 {
      background: url("@/assets/colorBg/purple2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Details3 {
      background: url("@/assets/shopping/shoppingIndex/details.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .OnlineShopping1 {
      background: url("@/assets/colorBg/red1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .OnlineShopping2 {
      background: url("@/assets/colorBg/red2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .OnlineShopping3 {
      background: url("@/assets/shopping/shoppingIndex/onlineShopping.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .BankTransfer1 {
      background: url("@/assets/colorBg/orange1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .BankTransfer2 {
      background: url("@/assets/colorBg/orange2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .BankTransfer3 {
      background: url("@/assets/shopping/shoppingIndex/bankTransfer.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .AntiFraudAPP1 {
      background: url("@/assets/colorBg/blue1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .AntiFraudAPP2 {
      background: url("@/assets/colorBg/blue2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .AntiFraudAPP3 {
      background: url("@/assets/shopping/shoppingIndex/antiFraudAPP.png")
        no-repeat center;
      background-size: 100% 100%;
    }
  }
  .health:nth-child(2n) {
    margin-right: 0;
  }
}

.prompt {
  width: 100%;
  position: absolute;
  bottom: 2vh;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #666666;
  text-align: center;
}
// }
</style>
